import { FC } from "react";
import { FooterBlockType, FooterWidgetBlockType } from "./block-prop-types";
import { FooterBlockConfig } from "../blocks";
import { BlockTheme } from "./block-theme";
import { BlockType } from "./block-type";
import { FCKameleonBlock, FCPrimaryBlock } from "./tetris-blocks";

export type FCFooterBlock<T extends FooterBlockType> = {
  blockConfig: FooterBlockConfig;
  blockTheme: BlockTheme;
  blockType: BlockType;
} & FC<T>;

export type FCFooterWidgetBlock<T extends FooterWidgetBlockType> = {
  blockType: BlockType;
} & FC<T>;

export const isFooterBlock = (f: FCKameleonBlock): f is FCPrimaryBlock<any> =>
  [BlockType.Footer, BlockType.FooterWidget].includes(
    (f as FCPrimaryBlock<any>).blockType
  );
